import React, { ReactNode } from 'react';
import { Stack } from '@cherre-frontend/ui';

export const ProviderSettingsGrid = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      display='grid'
      rowGap={1.5}
      columnGap={5}
      gridTemplateColumns={{ xs: '1fr', md: '1fr 1fr' }}
    >
      {children}
    </Stack>
  );
};
